// extracted by mini-css-extract-plugin
export default {"addToCartControl":"k5-z","giftCard":"l5-z","btnContainer":"m5-z","cartButton":"n5-z","disabled":"o5-z","stockMessage":"p5-z"};